import React from 'react';

export default () => (
  <svg
    focusable='false'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M16.377 1.875a.75.75 0 0 1 .75.75v1.75h2.75a2.25 2.25 0 0 1 2.25 2.25v13.25a2.25 2.25 0 0 1-2.25 2.25H4.127a2.25 2.25 0 0 1-2.25-2.25V6.625a2.25 2.25 0 0 1 2.25-2.25h2.75v-1.75a.75.75 0 0 1 .648-.743l.102-.007a.75.75 0 0 1 .75.75v1.75h7.25v-1.75a.75.75 0 0 1 .648-.743zm4.25 9H3.377v9c0 .414.335.75.75.75h15.75a.75.75 0 0 0 .75-.75v-9zm-13.75-5h-2.75a.75.75 0 0 0-.75.75v2.75h17.25v-2.75a.75.75 0 0 0-.75-.75h-2.75V7a.75.75 0 0 1-.649.743l-.101.007a.75.75 0 0 1-.75-.75V5.875h-7.25V7a.75.75 0 0 1-.649.743l-.101.007a.75.75 0 0 1-.75-.75V5.875z' />
  </svg>
);
